export default function Numpy_ArraySlicing() {
  return <div>Numpy_ArraySlicing Component</div>;
}
